import "./RichText.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import React, { useState, useCallback, useRef, useEffect } from "react";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

interface RichTextProps {
	defaultValue: any;
	mentions: any[];
	toolbar: any[];
	handleChange?: (value: string) => void;
	locale?: string;
}

const RichText: React.FC<RichTextProps> = ({
	handleChange,
	defaultValue,
	locale,
}) => {
	const editor = useRef<Editor>(null);
	const [contentSet, setContentSet] = useState(false);
	const [editorState, setEditorState] = useState(() =>
		EditorState.createEmpty(),
	);

	const onChange = useCallback(
		(state: EditorState) => {
			setEditorState(state);

			if (handleChange) {
				const draftRaw = convertToRaw(state.getCurrentContent());
				const htmlString = draftToHtml(draftRaw);

				handleChange(htmlString);
			}
		},
		[setEditorState, handleChange],
	);

	useEffect(() => {
		const draftBlocks = htmlToDraft(defaultValue.value || "");
		const { contentBlocks, entityMap } = draftBlocks;
		const contentState = ContentState.createFromBlockArray(
			contentBlocks,
			entityMap,
		);
		const newEditorState = EditorState.push(
			editorState,
			contentState,
			"change-block-data",
		);

		onChange(newEditorState);
		/* eslint-disable-next-line */
	}, [locale]);

	useEffect(() => {
		if (
			!contentSet &&
			defaultValue.async &&
			defaultValue.loaded &&
			defaultValue.value
		) {
			const draftBlocks = htmlToDraft(defaultValue.value);
			const { contentBlocks, entityMap } = draftBlocks;
			const contentState = ContentState.createFromBlockArray(
				contentBlocks,
				entityMap,
			);
			const newEditorState = EditorState.push(
				editorState,
				contentState,
				"change-block-data",
			);

			onChange(newEditorState);
			setContentSet(true);
		}
	}, [defaultValue, contentSet, onChange, editorState]);

	if (defaultValue.async && !defaultValue.loaded) {
		return null;
	}

	return (
		<div className={"RichText"}>
			<Editor
				ref={editor}
				spellCheck={true}
				editorState={editorState}
				onEditorStateChange={onChange}
				placeholder={"Text goes here..."}
				toolbarClassName={"RichText__toolbar"}
				toolbar={{
					options: ["inline", "list", "link"],
					inline: { options: ["bold", "italic", "underline"] },
					list: { options: ["ordered", "unordered"] },
				}}
			/>
		</div>
	);
};

export default React.memo(RichText);
